import Swiper from 'swiper';
import { Pagination, Navigation } from 'swiper/modules';

export default function swiperImageCardsGrid() {
    const selector = '.swiper-image-cards-grid';
    const elements = document.querySelectorAll(selector);
    
    if (!elements.length) return;

    const initSwiper = () => {
        elements.forEach(el => {
            if (!el.swiper) {
                new Swiper(el, {
                    modules: [Pagination, Navigation],
                    slidesPerView: 1.2,
                    spaceBetween: 20,
                    centeredSlides: true,
                    loop: true,
                    pagination: {
                        el: el.querySelector('.swiper-pagination'),
                        clickable: true,
                    },
                    navigation: {
                        nextEl: el.querySelector('.swiper-button-next'),
                        prevEl: el.querySelector('.swiper-button-prev'),
                    },
                    breakpoints: {
                        768: {
                            slidesPerView: 3,
                            spaceBetween: 30,
                            centeredSlides: false,
                        }
                    }
                });
            }
        });
    };

    initSwiper();
}
